import { hrService } from "../../../../../Api/Services/HRService";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";
import { IEmployyeManagerUpdate } from "../../../../../Types/EmployeeManagerUpdate";
import { IBaseResponse } from "../../../../../Types/UserProfileDetails";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";

export const updateEmployeeManagerThunk = createServiceAsyncThunk<
  IBaseResponse,
  IEmployyeManagerUpdate
>(
  ACTION_NAMES.UPDATE_EMPLOYEE_MANAGER,
  (employeeManagerData) => hrService.updateEmployeeManger(employeeManagerData),
  ERROR_MESSAGES.UPDATE_EMPLOYEE_MANAGER_FAILURE
);

const updateEmployeeManagerSlice = createGenericSlice<
  IBaseResponse,
  IEmployyeManagerUpdate
>(SLICE_NAMES.UPDATE_EMPLOYEE_MANAGER_SLICE, updateEmployeeManagerThunk);

// Export actions for dispatching
export const {
  clearError: clearUpdateEmployeeManagerErrors,
  clearSuccessMessage: clearSuccessUpdateEmployeeMangerResponse,
} = updateEmployeeManagerSlice.actions;

// Export the reducer for integration in the Redux store
export default updateEmployeeManagerSlice.reducer;
